import React, { useEffect } from 'react'

import { Trans } from '@mc/i18n'
import {
  BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME,
  StyledFeatureVariable,
} from '@mc/feature-variables'
import { useGiftEligiblePercentOff } from '@mc/promo-utils'
import { trackExperimentViewed } from '@mc/track-event'
import { useBucket } from '@mc/experiments-react'

import { PROMO_FEATURE_FLAG, PROMO_I18N_NAMESPACE } from '../../lib/constants'

const DefaultBannerPromoText = () => (
  <StyledFeatureVariable
    flagName={PROMO_FEATURE_FLAG}
    variableName={BANNER_OFFER_SLOGAN_BLUE_VARIABLE_NAME}
    defaultCopy={
      <>
        <Trans
          i18nKey='common.title'
          ns={PROMO_I18N_NAMESPACE}
          className='mc-text--center'
        >
          <span className='mc-text-color--tertiary' />
          <span className='mc-text-color--primary' />
        </Trans>
      </>
    }
  />
)

// https://app.growthbook.io/features/pen-4523_v1
const GIFT_BANNER_FLAG = 'pen-4523_v1'

export const BannerPromoText = () => {
  const percentOff = useGiftEligiblePercentOff()
  const bucket = useBucket(GIFT_BANNER_FLAG)
  const giftBannerExpAvailable = !!percentOff

  useEffect(() => {
    if (giftBannerExpAvailable) {
      trackExperimentViewed(GIFT_BANNER_FLAG)
    }
  }, [giftBannerExpAvailable])

  if (!percentOff || !bucket || bucket === 'control') {
    return <DefaultBannerPromoText />
  }
  return (
    <span className='mc-text--center'>
      {'Get '}
      <span className='mc-text-color--primary'>
        {percentOff}
        {'% off'}
      </span>
      {' memberships + gifts'}
    </span>
  )
}
